<div class="member-info-confirmation-modal-wrapper">
	<app-white-overlay>
		<div class="tw-w-[577px]!">
			<div class="content tw-w-full! tw-overflow-hidden">
				<div *ngIf="!editInfo">
					<p class="title">Hi {{ profile?.firstName }}, is the below info correct?</p>

					<div class="info-field">
						<span class="info-label" [translate]="'dashboard.member-account-info.first-name'"></span>
						<span class="info-value">{{ profile?.firstName }}</span>
					</div>

					<div class="info-field">
						<span class="info-label" [translate]="'dashboard.member-account-info.last-name'"></span>
						<span class="info-value">{{ profile?.lastName }}</span>
					</div>

					<div class="info-field">
						<span class="info-label" [translate]="'dashboard.member-account-info.home-address'"></span>
						<span class="info-value">{{ profile?.address }}</span>
						<span class="info-value" *ngIf="profile?.address2">{{ profile?.address2 }}</span>
						<span class="info-value">{{ profile?.city }}, {{ profile?.state }} {{ profile?.zipCode }}</span>
					</div>

					<div class="info-field">
						<span class="info-label" [translate]="'dashboard.member-account-info.preferred-email'"></span>
						<span class="info-value">{{ profile?.email }}</span>
					</div>

					<div class="info-field">
						<span class="info-label" [translate]="'dashboard.member-account-info.cell-phone'"></span>
						<span class="info-value">{{ profile?.cellPhone | maskPhone }}</span>
					</div>

					<div class="button-container">
						<button
							class="no-btn"
							(click)="incorrectInfoConfirmation()"
							appGoogleAnalytics
							[eventData]="{
								eventCategory: 'Button',
								eventAction: 'Click - No',
								eventLabel: 'Member Details - Need Changes'
							}"
							appEheAnalytics
							[data]="{
								pageUrl: '/dashboard',
								redirectedTo: '/account',
								componentName: 'member-info-confirmation-modal',
								id: 'Edit Personal Info',
								placement: 'Personal Info section'
							}">
							No, I need to edit
						</button>
						<button
							class="yes-btn"
							(click)="correctInfoConfirmation()"
							appGoogleAnalytics
							[eventData]="{
								eventCategory: 'Button',
								eventAction: 'Click - Yes',
								eventLabel: 'Member Details - Details Correct'
							}">
							Yes, this is correct
						</button>
					</div>
				</div>
			</div>

			<div *ngIf="editInfo" class="edit-content">
				<p class="title">My EHE Health Profile</p>
				<form [formGroup]="updateProfileForm" (ngSubmit)="savePersonalInfo()">
					<div class="edit-row">
						<div class="edit-field">
							<label class="edit-label">{{
								'account.profile.sections.personal-information.form.first-name' | translate
							}}</label>
							<input class="edit-input" formControlName="firstName" type="text" />
						</div>
						<div class="edit-field">
							<label class="edit-label">{{
								'account.profile.sections.personal-information.form.last-name' | translate
							}}</label>
							<input class="edit-input" formControlName="lastName" type="text" />
						</div>
					</div>

					<div class="edit-field">
						<label class="edit-label">{{
							'account.profile.sections.personal-information.form.address' | translate
						}}</label>
						<input class="edit-input" formControlName="address" type="text" maxlength="100" />
						<p
							class="edit-error"
							*ngIf="updateProfileForm.get('address')?.invalid && updateProfileForm.get('address')?.touched">
							Address is required.
						</p>
					</div>

					<div class="edit-field">
						<label class="edit-label">Address Line 2</label>
						<input class="edit-input" formControlName="address2" type="text" maxlength="100" />
					</div>

					<div class="edit-row">
						<div class="edit-field">
							<label class="edit-label">{{
								'account.profile.sections.personal-information.form.city' | translate
							}}</label>
							<input class="edit-input" formControlName="city" type="text" maxlength="50" />
							<p
								class="edit-error"
								*ngIf="updateProfileForm.get('city')?.invalid && updateProfileForm.get('city')?.touched">
								City is required.
							</p>
						</div>
						<div class="edit-field">
							<label class="edit-label">{{
								'account.profile.sections.personal-information.form.state' | translate
							}}</label>
							<div class="state-select-wrapper tw-flex tw-items-center">
								<mat-form-field class="state-edit-field" appearance="fill" subscriptSizing="dynamic">
									<mat-select #stateSelect formControlName="state" (openedChange)="stateDropdownOpen = $event">
										<mat-option value="">State</mat-option>
										<mat-option *ngFor="let state of states" [value]="state">{{ state }}</mat-option>
									</mat-select>
								</mat-form-field>
								<svg
									class="tw-shrink-0 tw-cursor-pointer tw-block tw-transition-transform tw-duration-200 tw-ease-in-out -tw-ml-6"
									[class.tw-rotate-180]="stateDropdownOpen"
									width="18"
									height="10"
									viewBox="0 0 18 10"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									(click)="stateSelect.open()">
									<path
										d="M8.51953 9.47375L0.519531 2.17646L2.3862 0.473755L8.51953 6.06835L14.6529 0.473755L16.5195 2.17646L8.51953 9.47375Z"
										fill="#0D3D60"
										stroke="white"
										stroke-width="0.7" />
								</svg>
							</div>
						</div>
						<div class="edit-field">
							<label class="edit-label">{{
								'account.profile.sections.personal-information.form.zip' | translate
							}}</label>
							<input class="edit-input edit-input-sm" formControlName="zipCode" type="text" maxlength="10" />
							<p
								class="edit-error"
								*ngIf="updateProfileForm.get('zipCode')?.invalid && updateProfileForm.get('zipCode')?.touched">
								Invalid zip.
							</p>
						</div>
					</div>

					<div class="edit-field">
						<label class="edit-label">{{
							'account.profile.sections.personal-information.form.cellnumber' | translate
						}}</label>
						<input class="edit-input" formControlName="cellPhone" type="text" />
						<p
							class="edit-error"
							*ngIf="updateProfileForm.get('cellPhone')?.invalid && updateProfileForm.get('cellPhone')?.touched">
							Valid phone number is required.
						</p>
					</div>

					<div class="edit-field">
						<label class="edit-label">{{
							'account.profile.sections.email-addresses.form.preferred-email' | translate
						}}</label>
						<input class="edit-input" formControlName="email" type="email" />
					</div>

					<div class="button-container">
						<button type="button" class="no-btn" (click)="cancel()">Cancel</button>
						<button type="submit" class="yes-btn">Save & Continue</button>
					</div>
				</form>
			</div>
		</div>
	</app-white-overlay>
</div>
